<!--多文件上传及展示-->
<template>
  <!-- <div class="wrap">
    <label class="name"><slot /></label>
    <el-badge :value="+images.length">
      <el-image :src="images[0] ? images[0].url : 'none'" fit="cover" :style="'width:' + width + 'px;height:' + height + 'px;'" :preview-src-list="images.map((row) => row.url)">
        <div slot="error" class="image-slot">暂无图片</div>
      </el-image>
    </el-badge>
    <el-link type="primary" icon="el-icon-upload" @click="onUploader" v-if="uploader">上传图片</el-link>
  </div> -->
  <el-carousel v-bind="$attrs">
    <el-carousel-item v-for="img in images" :key="img.id">
      <el-image :src="img.url" fit="cover">
        <div slot="error" class="image-slot">暂无图片</div>
      </el-image>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import uploaderPage from '@/views/system/file/multipleUpload'
export default {
  data () {
    return {
      images: []
    }
  },
  props: {
    objectId: { type: String, default: null },
    mode: { type: String, default: null }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      this.$apis.system.file.list({
        objectId: this.objectId,
        mode: this.mode
      }).then(res => {
        this.images = res
      }).catch(e => {
        this.$message.error(e)
      })
    },
    //传图
    onUploader () {
      this.$layer.iframe({
        title: '上传图片',
        area: ['500px', 'auto'],
        content: {
          parent: this,
          content: uploaderPage,
          data: {
            objectId: this.objectId,
            mode: this.mode,
            listtype: 'text',
            autoupload: true,
          }
        },
        cancel: () => {
          this.initData()
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.el-image {
  width: 100%;
  height: 100%;
}
</style>